import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Tooltip, Fab, Box } from "@mui/material";

// WeChat SVG icon (not in MUI icons)
const WeChatIcon = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.328.328 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.49.49 0 0 1 .176-.554C22.922 18.119 24 16.618 24 14.992c0-3.21-3.162-6.134-7.063-6.134zm-2.74 2.402c.537 0 .972.44.972.982a.977.977 0 0 1-.972.982.977.977 0 0 1-.972-.982c0-.542.435-.982.972-.982zm5.4 0c.537 0 .972.44.972.982a.977.977 0 0 1-.972.982.977.977 0 0 1-.972-.982c0-.542.435-.982.972-.982z" />
  </svg>
);

const FloatingWhatsApp = ({
  phoneNumber = "97688202020",
  message = "сайн уу",
  wechatId = "97686190001",
}) => {
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}${
    message ? `&text=${encodeURIComponent(message)}` : ""
  }`;

  const wechatUrl = `weixin://dl/chat?${wechatId}`;

  const fabBase = {
    color: "#fff",
    transition: "all 0.2s ease",
    zIndex: 1300,
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 50,
        right: 10,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        alignItems: "center",
      }}
    >
      {/* WeChat */}
      <Tooltip title="Chat on WeChat" placement="left">
        <Fab
          component="a"
          href={wechatUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            ...fabBase,
            bgcolor: "#07C160",
            boxShadow: "0 4px 16px rgba(7,193,96,0.45)",
            "&:hover": {
              bgcolor: "#06a050",
              transform: "scale(1.08)",
              boxShadow: "0 6px 24px rgba(7,193,96,0.55)",
            },
          }}
        >
          <WeChatIcon />
        </Fab>
      </Tooltip>

      {/* WhatsApp */}
      <Tooltip title="Chat on WhatsApp" placement="left">
        <Fab
          component="a"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            ...fabBase,
            bgcolor: "#25D366",
            boxShadow: "0 4px 16px rgba(37,211,102,0.45)",
            "&:hover": {
              bgcolor: "#1ebe5d",
              transform: "scale(1.08)",
              boxShadow: "0 6px 24px rgba(37,211,102,0.55)",
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 28 }} />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default FloatingWhatsApp;